module.exports = __webpack_public_path__ + "static/aws-developer-da418450b583e16e071b96e3bded824e.png";